/* global jQuery */
/* Site Info Banner Widget */

(function ($) {
  // Data service for the widget
  function widgetDataService() {
    this.getWidgetData = function (
      servicePath,
      widgetModuleItemID,
      successCallback,
      errorCallback,
    ) {
      $.ajax({
        type: 'POST',
        url: servicePath,
        data: "{'widgetModuleItemID':" + widgetModuleItemID + '}',
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
        success: successCallback,
        error: errorCallback,
      });
    };
  }

  // Global variables for the widget function
  let widgetData = null;
  let widgetContainer = null;
  let eventNameContentContainer = null;
  let eventDatesContentContainer = null;
  let numberOfDays;
  let previouslyViewedDate = true;
  let customConnector = null;
  let eventLength = null;
  let afterMessage = '';
  let siteInfoBannerLoaded = function () {};

  // Constructor for the widget
  $.fn.SiteInfoBanner = function (options) {
    let opts = $.extend({}, $.fn.SiteInfoBanner.defaultOptions, options);

    widgetContainer = this;

    eventNameContentContainer = widgetContainer.find('#eventName');
    eventDatesContentContainer = widgetContainer.find('#eventDates');
    previouslyViewedDate = opts.previouslyViewedDate;

    let widgetDataAdapter = new widgetDataService();

    widgetDataAdapter.getWidgetData(
      opts.scriptPath,
      opts.currentWidgetModuleItemID,
      getWidgetDataSuccess,
      getWidgetDataError,
    );

    customConnector = opts.customConnector;
    siteInfoBannerLoaded = opts.siteInfoBannerLoaded;
  };

  // Default options
  $.fn.SiteInfoBanner.defaultOptions = {
    scriptPath: 'services/eventsservice.asmx',
    currentWidgetModuleItemID: 0,
    previouslyViewedDate: true,
    customConnector: null,
    siteInfoBannerLoaded: function () {
      let daysContainer = $('#countdown-timer-days');
      let hoursContainer = $('#countdown-timer-hours');
      let minContainer = $('#countdown-timer-minutes');
      let secContainer = $('#countdown-timer-seconds');

      if (widgetData.NumberOfDays >= 1) {
        let daysUntilEvent = widgetData.NumberOfDays;

        function formatDate(date) {
          let monthNames = [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December',
          ];
          let day = date.getDate();
          let monthIndex = date.getMonth();
          let year = date.getFullYear();
          return day + ' ' + monthNames[monthIndex] + ' ' + year;
        }

        let currentDate = new Date();
        currentDate.setDate(currentDate.getDate() + daysUntilEvent);
        let coundownToThisDate = formatDate(currentDate);
        let countDownDate = new Date(coundownToThisDate).getTime();

        let x = setInterval(function () {
          let now = new Date().getTime();
          let distance = countDownDate - now;

          let days = Math.floor(distance / (1000 * 60 * 60 * 24));
          let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          let seconds = Math.floor((distance % (1000 * 60)) / 1000);

          daysContainer.html('<span>' + days + '</span>');
          hoursContainer.html('<span>' + hours + '</span>');
          minContainer.html('<span>' + minutes + '</span>');
          secContainer.html('<span>' + seconds + '</span>');

          if (distance < 0) {
            clearInterval(x);
            console.log('EXPIRED');
          }
        }, 1000);
      } else {
        daysContainer.text('0');
        hoursContainer.text('0');
        minContainer.text('0');
        secContainer.text('0');
      }
    },
  };

  // Success callback
  let getWidgetDataSuccess = function (data) {
    widgetData = data.d;
    initialize();
  };

  // Error callback
  let getWidgetDataError = function (data) {
    console.log(
      'Site Info Banner failed to load',
      '\n' + 'Status: ' + data.status + ' ' + data.statusText,
      '\n' + data.responseText,
    );
  };

  // UI initialization
  function initialize() {
    if (!widgetData.Enabled) return;

    if (widgetData.ShowAfterEventMessage) {
      afterMessage = widgetData.AfterEventMessage;
    }

    eventLength = widgetData.EventLength;
    numberOfDays = widgetData.NumberOfDays;

    let m = numberOfDays <= 0 ? numberOfDays + eventLength : 0;
    let i = numberOfDays + 50;

    if (numberOfDays > 0) {
      let until = customConnector != null ? customConnector : 'until';
      if (widgetData.LoadedFromCountdowns) until = '';

      eventDatesContentContainer.text(widgetData.DateString);

      if (!previouslyViewedDate) {
        setInterval(function () {
          if (i >= numberOfDays) {
            let dayWord = i === 1 ? 'day' : 'days';
            eventNameContentContainer.html(
              '<span class="countdownDays">' +
                i +
                ' <span class="dayWord">' +
                dayWord +
                '</span></span> ' +
                until +
                ' ' +
                widgetData.EventName,
            );
            i--;
          }
        }, 50);
      } else {
        let dayWord = numberOfDays === 1 ? 'day' : 'days';
        eventNameContentContainer.html(
          '<span class="countdownDays">' +
            numberOfDays +
            ' <span class="dayWord">' +
            dayWord +
            '</span></span> ' +
            until +
            ' ' +
            widgetData.EventName,
        );
      }
    } else if (m < 0) {
      if (widgetData.EventName != null) {
        eventDatesContentContainer.text(widgetData.EventName);
      }

      eventNameContentContainer.html('<span class="countdownDays">' + afterMessage + '</span>');

      if (afterMessage === '') {
        $('#widgetBanner').addClass('noThankYouMessage');
        $('body').addClass('siteInfoBannerWidgetNoThankYouMessage');
      }

      $('#widgetBanner').addClass('datePast');
      $('body').addClass('siteInfoBannerWidgetDateIsPast');
    } else {
      $('#siteInfoBannerWidget').css('display', 'block');
      eventDatesContentContainer.text(widgetData.DateString);
      eventNameContentContainer.css('display', 'none');
      $('#widgetBanner').addClass('eventHappening');
      $('body').addClass('siteInfoBannerWidgetEventHappening');
    }

    siteInfoBannerLoaded(widgetData);

    let infoBannerCountdownContent = $('.countdownDays').html();
    let infoBannerDatesContent = $('#eventDates').html();
    if (infoBannerCountdownContent === '' && infoBannerDatesContent === '') {
      $('body').addClass('siteInfoBannerOff');
    } else {
      $('body').addClass('siteInfoBannerOn');
    }

    widgetContainer.show();
    $('#countdown-timer').css('opacity', '1');
    $('#countdown-timer').attr('aria-hidden', 'true');
  }
})(jQuery);
